import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue')
    },
    {
      path: '/settings',
      name: 'settings',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Settings.vue')
    },
    {
      path: '/newevaluation/:templateId',
      name: 'newEvaluation',
      component: () => import(/* webpackChunkName: "about" */ './views/NewEvaluation.vue'),
      props: true
    },
    {
      path: '/evaluation/:evaluationId',
      name: 'evaluation',
      component: () => import(/* webpackChunkName: "about" */ './views/Evaluation.vue'),
      props: true
    },
    {
      path: '/result/:evaluationId',
      name: 'result',
      component: () => import(/* webpackChunkName: "about" */ './views/Result.vue'),
      props: true
    },
    {
      path: '/userSelect',
      name: 'userSelect',
      component: () => import(/* webpackChunkName: "about" */ './views/UserSelect.vue'),
      props: false
    },
    {
      path: '/participantOverview',
      name: 'participantOverview',
      component: () => import(/* webpackChunkName: "about" */ './views/ParticipantOverview.vue'),
      props: false
    },
    {
      path: '/participantDetail/:participantId',
      name: 'participantDetail',
      component: () => import(/* webpackChunkName: "about" */ './views/ParticipantDetail.vue'),
      props: true
    },
    {
      path: '*',
      name: 'default',
      component: () => import('./views/Home.vue')
    },
    
  ]
})
